import { useQuery } from '@tanstack/react-query';
import { aiAPI } from 'api/ai';

export const useAIModels = (enabled: boolean = true) => {
  const { data: aiModels, isLoading } = useQuery({
    queryKey: ['ai', 'models'],
    queryFn: aiAPI.getModels,
    enabled,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24, // 1 day
  });
  const defaultModel = aiModels?.find((model) => model.is_default);
  const defaultModelId = defaultModel?.id;
  return {
    isLoading,
    aiModels,
    defaultModelId,
  };
};
